export default __webpack_public_path__ + "static/media/webhooks.bd12f4cb.svg";